import { NavLink } from 'react-router'
import { FiArrowUpRight } from 'react-icons/fi'
import { Container, Reveal, RevealGroup, CircleBadge } from '@/components/common'
import { ctas } from '@/constants/final-cta'
import ctaBg from '@/assets/images/culture-chiefs.jpeg'

export const FinalCTA = () => {
  return (
    <section className="relative isolate overflow-hidden bg-ibon-dark">
      <div
        className="absolute inset-0 -z-20 bg-cover bg-center"
        style={{ backgroundImage: `url(${ctaBg})` }}
      />
      <div className="absolute inset-0 -z-10 bg-ibon-dark/90" />
      <div className="absolute -top-40 right-0 -z-10 h-96 w-96 rounded-full bg-ibon-sky/20 blur-[120px]" />

      <CircleBadge
        className="absolute right-8 top-12 hidden lg:grid"
        textClassName="fill-current text-white/60"
      />

      <Container className="flex flex-col items-center py-28 text-center lg:py-36">
        <Reveal variant="up" duration={650}>
          <span className="inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-white/60">
            <span className="h-px w-8 bg-ibon-sky" />
            Get Involved
          </span>
        </Reveal>

        <Reveal variant="up" delay={100} duration={800}>
          <h2 className="mt-7 max-w-4xl text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-white sm:text-5xl lg:text-6xl">
            Ready to <span className="text-white/40">get involved?</span>
          </h2>
        </Reveal>

        <Reveal variant="up" delay={180} duration={800}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg">
            Whether you are looking to partner with us, support our work, or contribute to our
            programmes, there is a place for you in the IBON World community, helping expand
            opportunity across Africa and the Caribbean.
          </p>
        </Reveal>

        <RevealGroup className="mt-14 grid w-full max-w-5xl gap-5 sm:grid-cols-3" step={100}>
          {ctas.map(({ to, label, description, Icon }) => (
            <NavLink
              key={to}
              to={to}
              className="group relative flex flex-col items-start gap-4 rounded-2xl border border-white/10 bg-white/5 p-7 text-left backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-ibon-sky/40 hover:bg-white/10"
            >
              <span className="absolute right-5 top-5 flex h-9 w-9 items-center justify-center rounded-full bg-white text-ibon-dark opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <FiArrowUpRight size={16} />
              </span>
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-ibon-sky/15 text-ibon-sky transition-colors duration-300 group-hover:bg-ibon-sky group-hover:text-ibon-dark">
                <Icon size={20} />
              </span>
              <span className="text-lg font-bold text-white">{label}</span>
              <span className="text-sm leading-relaxed text-white/60">{description}</span>
            </NavLink>
          ))}
        </RevealGroup>
      </Container>
    </section>
  )
}
